import './styles/global.css';
import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import VotePage from './pages/VotePage';
import ModelsPage from './pages/ModelsPage';
import ActressesPage from './pages/ActressesPage';
import DancersPage from './pages/DancersPage';
import { RegisterModalProvider } from './contexts/RegisterModalContext';
import { LanguageProvider } from './contexts/LanguageContext';

const HOME_PAGE_PASSWORD = '0345';

function HomePageAccessGate() {
  const [password, setPassword] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [error, setError] = useState('');

  function handleSubmit(event) {
    event.preventDefault();

    if (password === HOME_PAGE_PASSWORD) {
      setIsUnlocked(true);
      setError('');
      return;
    }

    setPassword('');
    setError('Неверный пароль');
  }

  if (isUnlocked) {
    return <HomePage />;
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 px-4 py-8 text-white">
      <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-md items-center justify-center">
        <form
          onSubmit={handleSubmit}
          className="w-full rounded-3xl border border-white/10 bg-white/10 p-6 shadow-2xl backdrop-blur-xl"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-sky-200/80">Protected Home</p>
          <h1 className="mt-3 text-3xl font-semibold text-white">Введите пароль</h1>
          <p className="mt-3 text-sm text-slate-300">Главная страница открывается только после ввода кода доступа.</p>

          <label className="mt-6 block text-sm font-medium text-slate-200" htmlFor="home-password-input">
            Пароль
          </label>
          <input
            id="home-password-input"
            type="password"
            inputMode="numeric"
            autoFocus
            maxLength={4}
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              if (error) {
                setError('');
              }
            }}
            className="mt-2 w-full rounded-2xl border border-white/15 bg-slate-950/40 px-4 py-3 text-lg tracking-[0.35em] text-white outline-none transition focus:border-sky-400 focus:ring-2 focus:ring-sky-500/30"
            placeholder="••••"
          />

          {error ? (
            <p className="mt-3 text-sm text-rose-300">{error}</p>
          ) : null}

          <button
            type="submit"
            className="mt-6 w-full rounded-2xl bg-sky-500 px-4 py-3 text-sm font-semibold text-slate-950 transition hover:bg-sky-400"
          >
            Открыть главную
          </button>
        </form>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <RegisterModalProvider>
        <Routes>
          <Route path="/" element={<HomePageAccessGate />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/actresses" element={<ActressesPage />} />
          <Route path="/dancers" element={<DancersPage />} />
          <Route path="/:slug/*" element={<VotePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </RegisterModalProvider>
    </LanguageProvider>
  );
}
